// extracted by mini-css-extract-plugin
export default {"container":"ManagementAreaNameFilter_container__aYRA3","content":"ManagementAreaNameFilter_content__h6z8o"};